import { UI_THEME_CHANGED } from "./types";

/**
 * Returns an action that the current UI theme has changed
 * @param {String} theme New theme identifier
 */
export const themeChanged = theme => ({
  type: UI_THEME_CHANGED,
  theme
});



// WEBPACK FOOTER //
// ./src/actions/settings.js